import $ from 'jquery';
const ignoreNode = function (node) {
  return node.nodeType !== undefined && node.nodeType === node.COMMENT_NODE || /META|STYLE|LINK|:/.test(node.tagName) || node.nodeType !== undefined && node.nodeType === node.ELEMENT_NODE && /mso\-list:Ignore/.test(node.getAttribute('style'));
};
const cleanText = function (text) {
  return text.replace(/<?!?\[endif\]>?|<?!?\[if\s+!?\w+\]>?|\s{2,}/g, '');
};
const nodeToHtml = function (node, allowedChildNodeNames) {
  let html = '';
  if (node.nodeType === undefined) {
    //node list
    let nodes = node;
    for (let i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (ignoreNode(node)) {
        //eslint-disable-next-line no-continue
        continue;
      }
      if (allowedChildNodeNames === undefined || node.nodeType === Node.TEXT_NODE || $.inArray(node.nodeName, allowedChildNodeNames) >= 0) {
        html += nodeToHtml(node);
      } else {
        html += cleanText(node.textContent);
      }
    }
    return html;
  } else {
    let listType;
    if (ignoreNode(node)) {
      return html;
    }
    let tagName = node.tagName;
    let className = node.className;
    if (className === 'MsoTitle') {
      return `<h1 class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A'])}</h1>`;
    } else if (className === 'MsoSubtitle') {
      return `<h2 class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A'])}</h2>`;
    } else if (/MsoList.*?First/.test(className)) {
      listType = 'ul';
      if (/\d+\./.test($(node).find('span[style*="mso-list:Ignore"]').text()) || /\d+\./.test($(node).find('span[style*="mso-list: Ignore"]').text())) {
        listType = 'ol';
      }
      return `<${listType} class='pl_editable_block'><li>${nodeToHtml(node.childNodes, ['A', 'B', 'I', 'SPAN'])}</li>`;
    } else if (/MsoList.*?Middle/.test(className)) {
      return `<li>${nodeToHtml(node.childNodes, ['A', 'B', 'I', 'SPAN'])}</li>`;
    } else if (/MsoList.*?Last/.test(className)) {
      listType = 'ul';
      if (/\d+\./.test($(node).find('span[style*="mso-list:Ignore"]').text()) || /\d+\./.test($(node).find('span[style*="mso-list: Ignore"]').text())) {
        listType = 'ol';
      }
      return `<li>${nodeToHtml(node.childNodes, ['A', 'B', 'I', 'SPAN'])}</li></${listType}>`;
    } else if (className === 'MsoQuote') {
      return `<p class='pl_editable_block'><i>${nodeToHtml(node.childNodes, ['A', 'B'])}</i></p>`;
    } else if ((className === 'MsoNormal' || tagName === 'P') && !/^(TH|TD)$/.test(node.parentNode.tagName)) {
      return `<p class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A', 'B', 'I', 'SPAN'])}</p>`;
    } else if (tagName === 'H1') {
      return `<h1 class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A'])}</h1>`;
    } else if (tagName === 'H2') {
      return `<h2 class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A'])}</h2>`;
    } else if (/H\d/.test(tagName)) {
      //H3, H4, H5 etc.
      return `<p class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A'])}</p>`;
    } else if (/^(TABLE|TBODY)$/.test(node.tagName)) {
      return nodeToHtml(node.childNodes, ['TR', 'TBODY']);
    } else if (tagName === 'TR') {
      return `<p class='pl_editable_block'>${nodeToHtml(node.childNodes, ['TD', 'TH'])}</p>`;
    } else if (/^(TH|TD)$/.test(tagName)) {
      return `${nodeToHtml(node.childNodes, ['A', 'B', 'I', 'P'])} `;
    } else if (tagName === 'B') {
      return `<b>${nodeToHtml(node.childNodes, ['A', 'I'])}</b>`;
    } else if (tagName === 'I') {
      return `<i>${nodeToHtml(node.childNodes, ['A', 'B'])}</i>`;
    } else if (tagName === 'A') {
      return `<a href=\"${node.href}\">${nodeToHtml(node.childNodes, ['I', 'B'])}</a>`;
    } else if (tagName === 'SPAN') {
      if (node.getAttribute('style') === 'mso-list: Ignore;') {
        return '';
      } else {
        return nodeToHtml(node.childNodes, ['SPAN', 'A']);
      }
    } else {
      return cleanText(node.textContent);
    }
  }
};
const cleanDocument = function (html) {
  // eslint-disable-next-line jquery-unsafe/no-html
  let $content = $('<div>').html(html);
  let nodes = $content[0].childNodes;
  let cleanedHtml = '';
  for (let i = 0, length = nodes.length; i < length; i++) {
    let node = nodes[i];
    if (node.nodeType === node.TEXT_NODE || node.nodeType === node.COMMENT_NODE || /META|STYLE|LINK/.test(node.tagName)) {
      //eslint-disable-next-line no-continue
      continue;
    }
    cleanedHtml += nodeToHtml(node);
  }
  return cleanedHtml;
};
const isWordDoc = function (html) {
  return /urn:schemas-microsoft-com:office:word|Mso(Title|Subtitle|List|Normal|TableGrid|Quote)/gi.test(html);
};
export default function (html) {
  if (isWordDoc(html)) {
    let tempHtml = html.replace(/\r\n/g, ' ');
    tempHtml = tempHtml.replace(/\n/g, ' ');
    return cleanDocument(tempHtml);
  }
  return html;
}